import { Route } from 'react-router-dom';
import MarketplaceGrid from '~/features/marketplace/MarketplaceGrid';

function Marketplace() {

  return (
    <Route path="/listings">
      <MarketplaceGrid />
    </Route>
  );
}

export default Marketplace;